import { FunctionComponent, useContext } from 'react'
import { CampaignContext } from '../src/state/CampaignContext'
import { ImageBrowser } from './ImageBrowser'
import { ProductOverview } from './ProductOverview'
import { AddToCartForm } from './AddToCartForm'
import { ProductTabs } from './ProductTabs'
import styles from './ProductSection.module.css'

export const ProductSection: FunctionComponent = () => {
  const { offer } = useContext(CampaignContext)

  return (
    <div className={`${styles.productSection} py-s3 switcher-l`}>
      <ImageBrowser images={offer.itemOffered.image} />

      <div className="stack-l gap-s3">
        <ProductOverview offer={offer} />
        <AddToCartForm />
        <ProductTabs />
      </div>
    </div>
  )
}
